module.exports = __webpack_public_path__ + "img/mccormick.76238d73.png";